import Select from "react-select";
import { useField } from "formik";

const selectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "auto",
    border: 0,
    boxShadow: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "14px 0 0",
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: 0,
    fontSize: 15,
    fontWeight: 500,
    color: "rgba(0, 0, 0, 0.85)",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    fontSize: 15,
  }),
  placeholder: (provided) => ({
    ...provided,
    margin: 0,
    fontSize: 15,
    color: "#999",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "10px 10px 0",
    color: "#333",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    transition: "transform .2s ease-in-out",
    "&:hover": { color: "#333" },
  }),
  menu: (provided) => ({
    ...provided,
    left: -16,
    width: "calc(100% + 17px)",
    marginTop: 12,
    border: "1px solid #dddddd",
    borderRadius: 6,
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
    overflow: "hidden",
    zIndex: 1000,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 260,
    padding: "4px 0",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "9px 15px",
    fontSize: 14,
    cursor: "pointer",
    fontWeight: state.isSelected ? 600 : 400,
    backgroundColor: state.isSelected ? "var(--primary-color)" : state.isFocused ? "#f5f5f5" : "#fff",
    color: state.isSelected ? "#fff" : "#333",
    "&:active": { backgroundColor: state.isSelected ? "var(--primary-color)" : "#ebebeb" },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize: 14,
  }),
};

export const FormikSelect = ({ name, options, placeholder = "Select", inputId, innerRef, ...rest }) => {
  const [field, , helpers] = useField(name);
  const { setValue, setTouched } = helpers;

  return (
    <Select
      name={name}
      inputId={inputId ?? name}
      ref={innerRef}
      options={options}
      value={options.find((opt) => opt.value == field.value) ?? null}
      onChange={(opt) => setValue(opt?.value ?? "")}
      onBlur={() => setTouched(true)}
      placeholder={placeholder}
      noOptionsMessage={() => "No matches found"}
      styles={selectStyles}
      {...rest}
    />
  );
};
